<template>
    <div class="footer_bottom_box">
        <div class="container">
            <!-- 上半部分 -->
            <el-row>
                <!-- 左侧友情链接 -->
                <el-col :span="16">
                    <el-row :gutter="20">
                        <!-- logo列 -->
                        <el-col :span="2">
                            <div class="footer_bottom_logo">
                                <img src="@/assets/img/footer/LOGO.png">
                            </div>
                        </el-col>
                        <!-- 链接部分 -->
                        <el-col :span="22">
                            <el-row>
                                <!-- 友情链接 -->
                                <el-col :span="3">
                                    <span class="footer_team_link_title">{{$t("message.footer.friendly")}}</span>
                                </el-col>
                                <el-col :span="21">
                                    <ul class="footer_bottom_friendly_link">
                                        <li v-for="(item,index) in friendly" :key="index">
                                        <a :href="item.link_url"  target="view_window">{{item.name}}</a>
                                        </li>
                                    </ul>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="3">
                                    <span class="footer_team_link_title">{{$t("message.footer.cooperate")}}</span>
                                </el-col>
                                <el-col :span="21">
                                    <ul class="footer_bottom_friendly_link">
                                        <li v-for="(item,index) in cooperation" :key="index">
                                        <a :href="item.cooperation_url"  target="view_window">{{item.name}}</a>
                                        </li>
                                    </ul>
                                </el-col>
                                <el-col :span="24">
                                    <p class="copyright">{{$t("message.footer.copyright")}}</p>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-col>
                <!-- 右侧其他 -->
                <el-col :span="8">
                    <div class="safe">
                        <img style="float:left; margin-right:5px;" src="@/assets/img/footer/safe_icon01.png">
                        <span>誠信網站企業典範</span>
                        <img style="float:left; margin-right:5px;" src="@/assets/img/footer/safe_icon02.png">
                        <span>可信網站信用評級</span>
                        <img style="float:left; margin-right:5px;" src="@/assets/img/footer/safe_icon03.png">
                        <span style="margin-right:0;">網上採購保障中心</span>
                        <div class="clearfix"></div>
                    </div>
                </el-col>
            </el-row>
            <!-- 下半部分 -->
            <div class="word">{{$t("message.footer.word")}}</div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
        }
    },
    computed: mapState({
        friendly: state => state.other.friendly,
        cooperation: state => state.other.cooperation,
    }),
}
</script>

<style scoped>
.footer_bottom_box .el-row:last-child{
  margin-bottom: 20px;
}

/* 组件盒子 */
.footer_bottom_box {
    background-color: #f5f5f5;
    padding-top: 33px;
}
/* 链接部分标题 */
.footer_team_link_title{
    font-size: 12px;
    color: #b0b0b0;
}
/* 友情链接 */
.footer_bottom_friendly_link>li{
    float: left;
    border-right: 1px solid #b0b0b0;
}
.footer_bottom_friendly_link>li:last-child{
    border-right: 0;
}
.footer_bottom_friendly_link>li>a{
    display: inline-block;
    padding: 0 10px;
    font-size: 12px;
    font-family: Arial,"\5B8B\4F53";
    color: #9a9a9a;
}
.footer_bottom_friendly_link>li>a:hover{
     color: #ff6700;
}
/* 版权 */
.copyright{
    color: #b0b0b0;
}
.safe{
    /* float: left; */
    text-align: right;
    width: 100%;
}
.safe>span{
    float: left;
    width: 60px;
    margin-right: 4px;
}
.word{
    margin: 0 auto;
    text-align: center;
    font-family: "华文行楷",sunself;
    font-size: 30px;
    color: #bababa;
    font-weight: normal;
    padding-bottom: 30px;
}
</style>
